export const CATEGORIES = [
  { id: "All", label: "All", icon: "Sparkles" },
  { id: "Parties", label: "Parties", icon: "PartyPopper" },
  { id: "House Parties", label: "House Parties", icon: "Home" },
  { id: "Celebrations", label: "Celebrations", icon: "Cake" },
  { id: "Music", label: "Music", icon: "Music2" },
  { id: "Disco", label: "Disco", icon: "Disc3" },
  { id: "Food", label: "Food", icon: "UtensilsCrossed" },
  { id: "College Events", label: "College", icon: "GraduationCap" },
  { id: "Lifestyle", label: "Lifestyle", icon: "Heart" },
  { id: "Pop", label: "Pop", icon: "Star" },
  { id: "Cafehopping", label: "Cafe Hopping", icon: "Coffee" },
  { id: "Hangout", label: "Hangout", icon: "Users" },
];

export const DEFAULT_CENTER = [28.6, 77.25]; // Delhi/Noida
export const DEFAULT_ZOOM = 11;

export const FALLBACK_LOGO =
  "https://images.unsplash.com/photo-1699217007718-d799af25caa4?crop=entropy&cs=srgb&fm=jpg&q=85&w=200";

export const THEMES = [
  {
    id: "simple",
    label: "Simple",
    tagline: "Clean city view",
    icon: "Map",
    tiles: "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png",
    attribution: '&copy; <a href="https://carto.com/">CARTO</a>',
    primary: "#2563eb",
    secondary: "#7c3aed",
    surface: "rgba(255, 255, 255, 0.76)",
    text: "#111827",
  },
  {
    id: "green",
    label: "Green",
    tagline: "Wellness trails",
    icon: "Leaf",
    tiles: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
    attribution: '&copy; <a href="https://carto.com/">CARTO</a>',
    primary: "#059669",
    secondary: "#84cc16",
    surface: "rgba(247, 253, 244, 0.82)",
    text: "#10251c",
  },
  {
    id: "disco",
    label: "Disco",
    tagline: "Nightlife pulse",
    icon: "Music2",
    tiles: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    attribution: '&copy; <a href="https://carto.com/">CARTO</a>',
    primary: "#ec4899",
    secondary: "#06b6d4",
    surface: "rgba(15, 23, 42, 0.76)",
    text: "#f8fafc",
  },
];
